import { getEventInfo } from 'api/eventpage';
import { concertCacheKey } from 'api/eventpage/cacheKeys';
import { useQuery } from 'react-query';

export const useConcertQuery = (eventKey?: string, invitationId?: string, enabled = true) => {
  if (!eventKey) {
    throw Error('No event eventKey found!');
  }

  const { isFetching, data, isError } = useQuery(
    concertCacheKey(eventKey, invitationId),
    async () => await getEventInfo(eventKey, invitationId),
    {
      cacheTime: 1000 * 60 * 30,
      staleTime: 1000 * 60 * 30,
      enabled,
    },
  );

  return {
    isFetching,
    data,
    isError,
  };
};
